// селекторы для создания popup'ов
// const selectors = '[data-popup], .perfomance__image>img, .swiper-slide>img, .profile__img>img';
const selectors = '[data-avpopup-cont]';

// <iframe width="560" height="315" src="//www.1tv.ru/embed/224461:12" allow="encrypted-media" frameborder="0" allowfullscreen></iframe>

// дефолтная картинка для попапа
// const defimage = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxNTAnIGhlaWdodD0nMTUwJyB2aWV3Qm94PScwIDAgMjQgMjQnPjxnIGZpbGw9J25vbmUnIHN0cm9rZT0nY3VycmVudENvbG9yJyBzdHJva2UtbGluZWNhcD0ncm91bmQnIHN0cm9rZS1saW5lam9pbj0ncm91bmQnIHN0cm9rZS13aWR0aD0nMic+PHBhdGggZD0nTTIgNmE0IDQgMCAwIDEgNC00aDEyYTQgNCAwIDAgMSA0IDR2MTJhNCA0IDAgMCAxLTQgNEg2YTQgNCAwIDAgMS00LTR6Jy8+PGNpcmNsZSBjeD0nOC41JyBjeT0nOC41JyByPScyLjUnLz48cGF0aCBkPSdNMTQuNTI2IDEyLjYyMUw2IDIyaDEyLjEzM0EzLjg2NyAzLjg2NyAwIDAgMCAyMiAxOC4xMzNWMThjMC0uNDY2LS4xNzUtLjY0NS0uNDktLjk5bC00LjAzLTQuMzk1YTIgMiAwIDAgMC0yLjk1NC4wMDYnLz48L2c+PC9zdmc+';
// const defimage = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCAzMDAgMzAwJz48bGluZWFyR3JhZGllbnQgaWQ9J2ExMSc+PHN0b3Agb2Zmc2V0PScwJyBzdG9wLWNvbG9yPScjMkQyRDJCJz48L3N0b3A+PHN0b3Agb2Zmc2V0PSc1JyBzdG9wLWNvbG9yPScjMkQyRDJCJyBzdG9wLW9wYWNpdHk9JzAnPjwvc3RvcD48L2xpbmVhckdyYWRpZW50PjxjaXJjbGUgZmlsbD0nbm9uZScgc3Ryb2tlPSd1cmwoI2ExMSknIHN0cm9rZS13aWR0aD0nOCcgc3Ryb2tlLWxpbmVjYXA9J3JvdW5kJyBzdHJva2UtZGFzaGFycmF5PScwIDE1IDAgMTUgMCAxNSAwIDE1IDAgMTUgMCAxNSAwIDM2MCcgY3g9JzE1MCcgY3k9JzE1MCcgcj0nMjUnIHRyYW5zZm9ybS1vcmlnaW49J2NlbnRlcic+PGFuaW1hdGVUcmFuc2Zvcm0gdHlwZT0ncm90YXRlJyBhdHRyaWJ1dGVOYW1lPSd0cmFuc2Zvcm0nIGNhbGNNb2RlPSdzcGxpbmUnIGR1cj0nMicgdmFsdWVzPScwOzM2MCcga2V5VGltZXM9JzA7MScga2V5U3BsaW5lcz0nMCAwIDEgMScgcmVwZWF0Q291bnQ9J2luZGVmaW5pdGUnPjwvYW5pbWF0ZVRyYW5zZm9ybT48L2NpcmNsZT48L3N2Zz4=';

const defimage = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCAzMDAgMzAwJz48bGluZWFyR3JhZGllbnQgaWQ9J2ExMSc+PHN0b3Agb2Zmc2V0PScwJyBzdG9wLWNvbG9yPScjZWZlYmUxJz48L3N0b3A+PHN0b3Agb2Zmc2V0PSc1JyBzdG9wLWNvbG9yPScjZWZlYmUxJyBzdG9wLW9wYWNpdHk9JzAnPjwvc3RvcD48L2xpbmVhckdyYWRpZW50PjxjaXJjbGUgZmlsbD0nbm9uZScgc3Ryb2tlPSd1cmwoI2ExMSknIHN0cm9rZS13aWR0aD0nOCcgc3Ryb2tlLWxpbmVjYXA9J3JvdW5kJyBzdHJva2UtZGFzaGFycmF5PScwIDE1IDAgMTUgMCAxNSAwIDE1IDAgMTUgMCAxNSAwIDM2MCcgY3g9JzE1MCcgY3k9JzE1MCcgcj0nMjUnIHRyYW5zZm9ybS1vcmlnaW49J2NlbnRlcic+PGFuaW1hdGVUcmFuc2Zvcm0gdHlwZT0ncm90YXRlJyBhdHRyaWJ1dGVOYW1lPSd0cmFuc2Zvcm0nIGNhbGNNb2RlPSdzcGxpbmUnIGR1cj0nMicgdmFsdWVzPScwOzM2MCcga2V5VGltZXM9JzA7MScga2V5U3BsaW5lcz0nMCAwIDEgMScgcmVwZWF0Q291bnQ9J2luZGVmaW5pdGUnPjwvYW5pbWF0ZVRyYW5zZm9ybT48L2NpcmNsZT48L3N2Zz4=';

// стиль для черного задника:
const blackscreenstyle = `
    touch-action: manipulation;
    position:fixed;
    overflow: hidden;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,.8);
    z-index:999;
    display:flex;
    justify-content: center;
    align-items: center;
    opacity:0;
    display:none;
    transition: opacity .75s;
  `;
// стиль для фрэйма-рамки:
const innerdivstyle = `
    position:relative;
    margin:auto;
    width:auto;
    width: 1250px;
    max-width: 90vw;
    max-height: 90vh;
    min-width: 300px;
    min-height: 300px;
    padding: 1rem;
    background: white;
    overflow-y: auto;
    overflow-x: hidden;
  `;
// стиль для изображения:
// const imagestyle = `
//     max-width:95vw;
//     max-height:95vh;
//     opacity: 1;
//     transition: opacity .5s, transform .05s;
//   `;
// стиль для кнопки закрытия:
const xdivstyle = `
    position:absolute;
    width:30px;
    height:30px;
    right:0;
    top:0;
    background:rgb(239, 235, 225);
    background-image: url('data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PScwIDAgNDYgNDYnIGZpbGw9J2JsYWNrJyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnPjxnIHRyYW5zZm9ybT0ncm90YXRlKDQ1IDIzIDIzKSc+PHJlY3QgeD0nMjInIHk9JzAnIHdpZHRoPScyJyBoZWlnaHQ9JzQ2Jy8+PHJlY3QgeD0nMCcgeT0nMjInIHdpZHRoPSc0NicgaGVpZ2h0PScyJy8+PC9nPjwvc3ZnPg==');
    background-size: contain;
    cursor:pointer;
  `;

const popup = document.querySelector(".av-popupcont") || document.createElement('div');
popup.className = "av-popupcont";
popup.style.cssText = blackscreenstyle;
popup.innerHTML = `<div style="${innerdivstyle}"></div><div style="${xdivstyle}"></div>`;
document.body.appendChild(popup);
popup.addEventListener("click", (e) => { e.target == popup && closePopup() });


/////////////////////////////////////////////////////////////////////////

function closePopup() {
    popup.style.opacity = 0, setTimeout(() => { popup.style.display = 'none'; popup.firstChild.innerHTML = ""; }, 750);
    document.body.style.touchAction = "pan-x pan-y";
    enableBodyScroll();
}

function initPopup() {
    [...document.querySelectorAll(selectors)].forEach((el) => {
        const targetEl = document.getElementById(el.dataset.avpopupCont);
        if (targetEl && targetEl.childNodes.length > 1) {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                document.body.style.touchAction = "none";
                disableBodyScroll();
                popup.firstChild.innerHTML = targetEl.innerHTML;
                popup.lastChild.addEventListener("click", closePopup);
                popup.firstChild.scrollTo(0, 0);
                popup.style.display = 'flex', setTimeout(() => { popup.style.opacity = 1; }, 100);
                // popup.style.opacity = 1;
            });

        } else {
            el.setAttribute("disabled", "disabled");
            console.log(`Не могу найти элемент ${el.dataset.avpopupCont}`);
        }

    });
}


function disableBodyScroll() {
    if (!document.body.classList.contains('body--fixed')) {
        document.body.style.top = `-${window.scrollY || window.pageYOffset || 0}px`;
        document.body.style.position = 'fixed';
        document.body.classList.add('body--fixed');
    }
}

function enableBodyScroll() {
    const scrollY = document.body.style.top;

    document.body.style.position = '';
    document.body.style.top = '';
    // window.scrollTo(0, parseInt(scrollY || '0') * -1);
    window.scrollTo({ top: parseInt(scrollY || '0') * -1, behavior: "instant" });
    document.body.classList.remove('body--fixed');
}



export default function () {
    window.addEventListener('DOMContentLoaded', () => {
        setTimeout(initPopup, 500);
    });
}